<template>
	<form @submit.prevent="handleSubmit" @keydown.enter.prevent="handleSubmit">
		<slot />
	</form>
</template>

<script>
/**
 * Generischer Formular-Wrapper.
 *
 * Kapselt:
 * - Enter-Submit via @keydown.enter.prevent
 * - Loading-Guard gegen Doppel-Submit
 * - Blur-Flush des fokussierten Feldes vor dem Submit (siehe handleSubmit)
 *
 * Autofill-Sync (Browser-gespeicherte Zugangsdaten) ist bewusst nicht enthalten
 * und muss bei Bedarf im submit()-Handler der Parent-Komponente per DOM-Read gelöst werden.
 * Siehe AuthLogin.vue als Referenz.
 */
export default {
	props: {
		loading: {
			type: Boolean,
			default: false,
		},
	},

	methods: {
		/**
		 * Blur des fokussierten Feldes, dann Submit emittieren.
		 *
		 * Hintergrund: Ui/Input gibt seinen Wert erst on-blur nach oben. Beim Button-Klick
		 * blurt der Klick das Feld ohnehin; bei Enter-Submit passiert das nicht, sodass der
		 * zuletzt getippte Wert sonst nicht im form landet. Daher hier explizit blurren.
		 * Das Relay läuft über einen async val-Watcher (Ui/InputGroup) — deshalb ein nextTick
		 * abwarten, bevor der Parent im submit-Handler den Wert liest.
		 *
		 * @return {void}
		 */
		async handleSubmit() {
			if (this.loading) return;

			if (document.activeElement instanceof HTMLElement) {
				document.activeElement.blur();
			}

			await this.$nextTick();

			this.$emit("submit");
		},
	},
};
</script>
